import React from "react";
import { Stack } from "@mui/material";

import { DialogButton, HubButton } from "../../components";

const LaborButtonBar = ({
  allowRework = false,
  disabled,
  isLoading,
  workOrder,
}) => {
  return (
    <Stack gap="10px" alignItems="center" justifyContent="center">
      <Stack direction="row" justifyContent="center" gap="10px">
        {allowRework && (
          <DialogButton
            id="save"
            name="create-route-rework"
            variant="contained"
            color="neutral"
            size="small"
            label="Flag Rework (Marcar Retrabajo)"
            disabled={disabled}
            isLoading={isLoading}
          />
        )}
        <HubButton
          id="submit"
          variant="contained"
          type="submit"
          size="small"
          label="Close Ticket (Confirmar)"
          disabled={disabled}
          isLoading={isLoading}
        />
      </Stack>
      <HubButton
        label="Order Details (Detalles Del Orden)"
        page={`/works/${workOrder}`}
        size="small"
        sx={{ span: { textWrap: "nowrap", fontWeight: 600 } }}
      />
    </Stack>
  );
};

export default LaborButtonBar;
